import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ActionMenuItem, MenuGroupButtonComponent} from '../menu-group-button/menu-group-button.component';
import { MatTooltip } from '@angular/material/tooltip';
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {SuperObjectModel} from "../../../../core/definitions/super-object-model";
import {MatDialog} from "@angular/material/dialog";
import {ObjectPageQrCodeDialog} from "../../../object-page-qr-code-dialog/object-page-qr-code-dialog";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-object-page-operations-toolbar',
  imports: [
    MatTooltip,
    MenuGroupButtonComponent,
    MatIconButton,
    MatIcon,
    TranslatePipe
  ],
    templateUrl: './object-page-operations-toolbar.component.html',
    styleUrl: './object-page-operations-toolbar.component.scss'
})
export class ObjectPageOperationsToolbarComponent {
  private readonly dialog: MatDialog = inject(MatDialog);

  @Input() actions: ActionMenuItem[];
  @Input() disabled?: boolean = false;
  @Input() readonly?: boolean = false;
  @Input() artifact?: SuperObjectModel;

  @Output() actionClick = new EventEmitter<ActionMenuItem>();

  onActionClick(action: ActionMenuItem) {
    this.actionClick.emit(action);
  }

  onGenerateQrCodeClick(): void {
    this.dialog.open(ObjectPageQrCodeDialog, {
      data: {
        artifact: this.artifact
      },
      panelClass: 'qr-code-dialog-override'
    });
  }
}
